import { forwardRef } from "react";
import clsx from "clsx";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./ButtonIcon.module.css";

type ButtonIconType = React.ForwardRefRenderFunction<
	HTMLDivElement,
	{
		icon: IconProp;
		className?: string;
		title?: string;
		inverted?: boolean;
		style?: React.CSSProperties;
		size?:
			| "xs"
			| "lg"
			| "sm"
			| "1x"
			| "2x"
			| "3x"
			| "4x"
			| "5x"
			| "6x"
			| "7x"
			| "8x"
			| "9x"
			| "10x";
		onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
	}
>;

const ButtonIcon: ButtonIconType = (
	{ icon, className, inverted, size, onClick, ...dataProps },
	ref
) => (
	<div
		ref={ref}
		className={clsx(styles.icon, inverted && styles.inverted, className)}
		onClick={onClick}
		{...dataProps}
	>
		<FontAwesomeIcon icon={icon} size={size} />
	</div>
);

export default forwardRef(ButtonIcon);
